import React, { Component } from 'react';
import { Menu } from 'semantic-ui-react';
import { lowerCase, split } from 'lodash';
import { Link, withRouter } from 'react-router-dom';

export class DeskTopTabletMenu extends Component {
  render() {
    let activeItem = split(this.props.location.pathname, '/')[1];
    if (activeItem === '') {
      activeItem = 'home';
    }
    const { menuItems } = this.props;
    return (
      <Menu pointing secondary className="Header__TitleBar__Menu--NotMobile">
        {menuItems.map(({ name, link }) => (
          <Link to={link} key={name}>
            <Menu.Item
              as="p"
              className="Header__TitleBar__Menu--NotMobile__Item"
              active={activeItem === lowerCase(name)}
            >
              {name}
            </Menu.Item>
          </Link>
        ))}
      </Menu>
    );
  }
}

export default withRouter(DeskTopTabletMenu);



// WEBPACK FOOTER //
// ./src/components/Header/Menu/DesktopTabletMenu.js